import { createApiClient } from '@f2m3/shared-api';
import { apiURL } from '../../config/endpoints';
import { responseCallbacks } from '../callbacks/callbacks';
import i18next from '../../i18n';

const apiClient = createApiClient({
  apiURL,
  getToken: () => localStorage.getItem('token'),
  getLocale: () => i18next.language,
  onResponse: responseCallbacks,
});

export default apiClient;

export { isApiError, API_ERROR_TYPES } from '@f2m3/shared-api';
export type {
  ApiError,
  ApiErrorType,
  ApiResponseEnvelope,
  RequestContext,
  RequestOptions,
} from '@f2m3/shared-api';
